import React from "react";
import { Helmet } from "react-helmet";

function SEO({ title, description, keywords, canonicalUrl }) {
  const siteTitle = "São José Ortopédicos";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const defaultDescription = "São José Ortopédicos - Próteses e órteses sob medida. Há mais de 30 anos oferecendo soluções em produtos ortopédicos, próteses, órteses, médico-hospitalar e fisioterapia.";
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content="website" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
    </Helmet>
  );
}

export default SEO;
